import SimpleDialog from '@/libs/material/simple-dialog';
import { routes } from '@/utils/routes';
import { DS_BREAKPOINT, DS_HEIGHT } from '@calm/evexia-design-tokens';
import { QrCode } from '@rhg/components/qr-code';
import { Box, Button, Theme, Typography } from '@rhg/libs/material';
import { useId, useState } from 'react';
import { useIntl } from 'react-intl';
import { navItemsMessages } from '../nav-items/messages';
import { qrCodeBannerMessages } from './messages';

const styleDialogContent = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: DS_BREAKPOINT.LARGE,
    maxWidth: '100%',
};
const styleQrCode = {
    width: DS_HEIGHT.AVATAR_XXLARGE,
    height: DS_HEIGHT.AVATAR_XXLARGE,
    '& img': {
        width: '100%',
        height: '100%',
        scale: 'calc(140/128)',
    },
    mb: (theme: Theme) => (theme.palette.mode === 'light' ? 0 : 4),
};

export const QrCodeBanner = () => {
    const id = useId();
    const { formatMessage } = useIntl();
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    return (
        <>
            <Button
                size="medium"
                trackButton="UseMobileApp"
                variant="outlined"
                onClick={() => setIsDialogOpen(true)}
            >
                {formatMessage(navItemsMessages.useMobileAppCta)}
            </Button>

            <SimpleDialog
                trackDialog="LookingForCalmApp"
                aria-labelledby={id}
                maxWidth="lg"
                isOpen={isDialogOpen}
                trackCloseButton="UseMobileAppBannerClose"
                onClose={() => setIsDialogOpen(false)}
                content={
                    <Box sx={styleDialogContent}>
                        <QrCode
                            url={routes.external.appDownloadDeeplink}
                            sx={styleQrCode}
                        />
                        <Typography
                            variant="h6"
                            color="text.body"
                            mb={2}
                            id={id}
                        >
                            {formatMessage(
                                qrCodeBannerMessages.downloadAppCopy
                            )}
                        </Typography>
                        <Typography variant="body1" color="text.body" mb={6}>
                            {formatMessage(qrCodeBannerMessages.scanQrCodeCopy)}
                        </Typography>
                    </Box>
                }
            />
        </>
    );
};
